import request from '@/request/request'

/**
 * 保存权证信息
 * @param {} parameter 
 * @returns 
 */
export function getPublishProjectNum () {
  return request({
    url: '/e-find-property/publicInfo/getPublishProjectNum',
    method: 'get',
  })
}

/**
 * 保存权证信息
 * @param {} parameter 
 * @returns 
 */
export function listProject (parameter) {
  return request({
    url: '/e-find-property/publicInfo/listProject',
    method: 'post',
    data: parameter
  })
}

/**
 * 保存权证信息
 * @param {} parameter 
 * @returns 
 */
export function getBidProject (parameter) {
  return request({
    url: '/e-find-property/publicInfo/getBidProject',
    method: 'get',
    params: parameter
  })
}

/**
 * 保存权证信息
 * @param {} parameter 
 * @returns 
 */
export function getIntentLease (parameter) {
  return request({
    url: '/e-find-property/publicInfo/getIntentLease',
    method: 'get',
    params: parameter
  })
}